const Contants = {
  MESSAGE: {
    LoginSuccess: "Login successfully!",
    RequiredUserInfo: "Please input user info!",
    UserNotExist: "User does not exist!",
    LogoutSuccess: "Logout successfully!",
    NotAuthorization: "You don't have authorization!",
    WannaLogout: "Do you really want to logout?",
    UpdateSuccess: "Update successfully!",
    UpdateError: "Update error!",
    InvalidData: "Invalid data. Please check the input!",
    WrongPassword: "Wrong password!",
    PasswordSuccess:
      "Change password successfully. Please login with your new password!",
  },
  RESPONSE_TYPES: {
    Success: "Success",
    Error: "Error",
    Warning: "Warning",
  },
  STATUS: {
    Active: 1,
    InActive: 2,
  },
  STATUS_TEXT: {
    1: "Active",
    2: "Inactive",
  },
  IDEA_STATUS: {
    New: 1,
    Approved: 2,
    Declined: 3,
    NeedsInfo: 4,
  },
  IDEA_STATUS_TEXT: {
    1: { text: "New", color: "warning" },
    2: { text: "Approved", color: "success" },
    3: { text: "Declined", color: "danger" },
    4: { text: "Needs info", color: "info" },
  },
  CHALLENGE_STATUS: {
    New: 1,
    Solved: 2,
    Declined: 3,
    NeedsInfo: 4,
  },
  CHALLENGE_STATUS_TEXT: {
    1: { text: "New", color: "warning" },
    2: { text: "Solved", color: "success" },
    3: { text: "Declined", color: "danger" },
    4: { text: "Needs info", color: "info" },
  },
  SIP_ROLES: {
    Admin: "ADM",
    Mod: "MOD",
    Member: "MEM",
  },
  SIP_ROLES_TEXT: {
    "ADM": "Administrator",
    "MOD": "Moderator",
    "MEM": "Member"
  },
  SIP_ACTION_TYPES:
  {
      Post: 1,
      Update: 2,
      Approve: 3,
      NeedsInfo: 4,
      Reject: 5,
      AddSolution: 6,
      ApproveSolution: 7,
      ChallengeSolved: 8,
  },
  NOTICE_STATUS: {
    New: 1,
    Read: 2
  },
  ENTITY_NAMES: {
    Idea: 'Idea',
    Challenge: 'Challenge'
  }
};
Contants.install = function (Vue) {
  Vue.prototype.$const = Contants;
};
export default Contants;
